import { IActionContext } from '@msdyn365-commerce/core';
import { OrgUnitLocation, SearchArea } from '@msdyn365-commerce/retail-proxy';
import { GenericInput, IFullOrgUnitAvailability } from '@msdyn365-commerce-modules/retail-actions';
import { getOrgUnitLocationsByAreaAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/OrgUnitsDataActions.g';

import storeSelectorStateDataAction from '../../modules/mmx-store-selector/state-manager/store-selector-state-manager-data-action';
import { IStoreInfo, IStoreSelectorStateManager, MapStoreSelectorStateManager } from '../../modules/mmx-store-selector/state-manager';

export async function getStoreSelectorStateManager(
    actionContext: IActionContext,
    className?: string
): Promise<IStoreSelectorStateManager | undefined> {
    return storeSelectorStateDataAction(
        new GenericInput<IStoreSelectorStateManager>(
            className ?? 'mmx-store-dropdown',
            new MapStoreSelectorStateManager(),
            'IStoreSelectorStateManager'
        ),
        actionContext
    );
}

export function getOrgUnitLocationFromStore(fullOrgUnitAvailability: IFullOrgUnitAvailability): OrgUnitLocation | undefined {
    return fullOrgUnitAvailability.OrgUnitLocation ?? fullOrgUnitAvailability.OrgUnitAvailability?.OrgUnitLocation;
}

export async function getStores(actionContext: IActionContext): Promise<IFullOrgUnitAvailability[]> {
    const searchArea: SearchArea = {
        Radius: 0
    };
    const stores = await getOrgUnitLocationsByAreaAsync({ callerContext: actionContext }, searchArea);
    return stores.map(store => {
        return { OrgUnitLocation: store };
    });
}

export async function getPreferredStoreLocation(actionContext: IActionContext, className?: string): Promise<IStoreInfo | undefined> {
    const storeSelectorStateManager = await getStoreSelectorStateManager(actionContext, className);
    return storeSelectorStateManager?.preferredStore;
}
